export default __webpack_public_path__ + "static/media/todo-tdd.6763a8ae.jpg";